import React from 'react';
import { Modal as ModalNew } from './Modal';
import { convertOldModalProps } from './converter.old';
import type { OldModalButtonProps, OldModalProps } from './converter.old';

export type ModalButtonProps = OldModalButtonProps;
export type ModalProps = OldModalProps;

export const Modal = (props: React.PropsWithChildren<ModalProps>) => <ModalNew {...convertOldModalProps(props)} />;
